const actions = {
    CHANGE_CURRENT_MENU: "CHANGE_CURRENT_MENU",
    changeCurrentMenu: currentMenu => ({
        type: actions.CHANGE_CURRENT_MENU,
        currentMenu: currentMenu
    })
};
export default actions;
